import DirectDebitBacsHeader from './direct-debit-bacs-header';

export default DirectDebitBacsHeader;
